export default {
  'primary': '#00441F',
  'secondary': '#00CF7B',
  'accent': '#00441F'
}
